import React, { useEffect, useState } from 'react'
import Tabs from './components/Tabs'

export const PROPERTY_TYPES = {
  LOAN_TYPE_BTL: 'LOAN_TYPE_BTL',
  LOAN_TYPE_CRE: 'LOAN_TYPE_CRE',
}

export const DISCOUNTS = {
  INTEREST_10: 'Vastgoedbelang 0,10%',
  INTEREST_20: 'Vastgoedbelang 0,20%',
}

const DISCOUNT_VALUE = {
  INTEREST_10: 0.1,
  INTEREST_20: 0.2,
}

// Which backend data source each tab reads from. BasiQ (2) and ClassiQ (4)
// share the 'standard' payload; ClassiQ is derived from it client-side.
const TAB_DATA_SOURCE = {
  1: 'basiq_select',
  2: 'standard',
  3: 'classiq_select',
  4: 'standard',
  5: 'cre',
}

const DATA_SOURCE_URL = {
  standard: process.env.REACT_APP_SIP_URL_INTEREST,
  cre: process.env.REACT_APP_SIP_URL_CRE_INTEREST,
  basiq_select: process.env.REACT_APP_SIP_URL_BASIQ_SELECT_INTEREST,
  classiq_select: process.env.REACT_APP_SIP_URL_CLASSIQ_SELECT_INTEREST,
}

export default function App() {
  const [interests, setInterests] = useState({})
  const [isError, setIsError] = useState(false)
  const [typeOnderpand, setTypeOnderpand] = useState(PROPERTY_TYPES.LOAN_TYPE_BTL)
  const [discountValue, setDiscountValue] = useState(0)
  const [discount, setDiscount] = useState('')
  const [currentTab, setCurrentTab] = useState('1')
  const [isLoading, setIsLoading] = useState(false)
  const [loadedDataSource, setLoadedDataSource] = useState(null)

  const onTypeOnderpandChange = (typeOnderpand) => {
    setDiscount('')
    setDiscountValue(0)
    setTypeOnderpand(typeOnderpand)
  }

  const onTabChange = (tabId) => {
    setCurrentTab(tabId)
  }

  const onDiscountChange = (discount) => {
    setDiscount(discount)
    const discountValue = discount !== '' && discount !== undefined ? DISCOUNT_VALUE[discount] : 0
    setDiscountValue(discountValue)
  }

  const onFilterClick = () => {
    setDiscount('')
    setDiscountValue(0)
  }

  useEffect(() => {
    const requiredDataSource = TAB_DATA_SOURCE[currentTab] || 'standard'

    if (loadedDataSource === requiredDataSource) {
      return
    }

    setIsLoading(true)
    setInterests({})

    const token = process.env.REACT_APP_SIP_TOKEN
    const config = {
      headers: { Authorization: `Bearer ${token}` },
      // params: { calculationDate: calculationDate || null }
    }

    const fetchUrl = DATA_SOURCE_URL[requiredDataSource]

    fetch(fetchUrl, config)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.rvps) {
          data.rvps.forEach(function (rvp) {
            rvp.interests = []
          })

          data.interests.forEach(function (interest) {
            data.rvps.forEach(function (rvp, index) {
              if (rvp.id === interest.rvpId) {
                data.rvps[index].interests.push(interest)
              }
            })
          })

          // Separate the ltvdIds to be used as index for sorting the interests
          const ltvIds = data.ltvs.map(function (header) {
            return header.id
          })

          data.rvps.forEach(function (rvp) {
            rvp.interests.sort(function (a, b) {
              return ltvIds.indexOf(a.ltvId) - ltvIds.indexOf(b.ltvId)
            })
          })
          setInterests(data)
          setLoadedDataSource(requiredDataSource)
        } else {
          console.log('API Error')
          setIsError(true)
        }
      })
      .catch((error) => {
        console.log('API Error', error)
        setIsError(true)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [currentTab, loadedDataSource])

  return (
    <div className="calculator-wrapper mx-auto text-lg text-secondary-100">
      <div className="bg-primary-100 py-6 px-4 lg:px-16 lg:py-14 rente-border-radius text-lg text-white min-h-[985px] overflow-y-auto rente-border-radius">
        {!isError && (
          <Tabs
            interests={interests}
            onTypeOnderpandChange={onTypeOnderpandChange}
            typeOnderpand={typeOnderpand}
            discount={discount}
            onDiscountChange={onDiscountChange}
            discountValue={discountValue}
            onFilterClick={onFilterClick}
            currentTab={currentTab}
            onTabChange={onTabChange}
            isLoading={isLoading}
          />
        )}
        {isError && 'De rentetarieven kunnen niet worden opgehaald. Probeer het later opnieuw.'}
      </div>
    </div>
  )
}
